export default {
  sizes: {
    md: {
      fontWeight: 'medium'
    }
  }
};